<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="TOC-Title" id="toc_marker-3">Contents</p>
<p class="TOC-Body-Text" id="toc1"><a href="#/CoverImage">Cover</a></p>
<p class="TOC-Body-Text" id="toc2"><a href="#/Healy_Hauerwas3#toc_marker-1">Dedication</a></p>
<p class="TOC-Body-Text" id="toc3"><a href="#/Healy_Hauerwas6#toc_marker-4">Acknowledgments</a></p>
<p class="TOC-Body-Text" id="toc4"><a href="#/Healy_Hauerwas7#toc_marker-5">Abbreviations for Books by Stanley Hauerwas</a></p>
<p class="TOC-Body-Text" id="toc5"><a href="#/Healy_Hauerwas8#toc_marker-6">1. Reading Hauerwas; Reading This Book</a></p>
<p class="TOC-Body-Text" id="toc6"><a href="#/Healy_Hauerwas9#toc_marker-7">2. The Church, the Center</a></p>
<p class="TOC-Body-Text" id="toc7"><a href="#/Healy_Hauerwas10#toc_marker-8">3. An Ecclesiocentric Method</a></p>
<p class="TOC-Body-Text" id="toc8"><a href="#/Healy_Hauerwas11#toc_marker-9">4. The Empirical Church and Christian Identity</a></p>
<p class="TOC-Body-Text" id="toc9"><a href="#/Healy_Hauerwas12#toc_marker-10">5. Hauerwas’s Theology</a></p>
<p class="TOC-Body-Text" id="toc10"><a href="#/Healy_Hauerwas13#toc_marker-11">Bibliography</a></p>
<p class="TOC-Body-Text" id="toc11"><a href="#/Healy_Hauerwas14#toc_marker-12">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Healy_Hauerwas-5.vue?6abb3bfe